var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1814 8.51715H29.7782V4.60216C29.7782 2.96823 28.4489 1.63885 26.8149 1.63885H5.32198C2.95021 1.63885 0.994691 3.45298 0.768952 5.76642C0.734477 5.92988 0.746753 4.47329 0.746753 27.0341C0.746753 29.5569 2.79915 31.6093 5.32191 31.6093H30.1813C31.8153 31.6093 33.1446 30.28 33.1446 28.646V11.4805C33.1447 9.84653 31.8153 8.51715 30.1814 8.51715ZM5.32198 3.67433H26.8149C27.3266 3.67433 27.7428 4.09057 27.7428 4.60222V8.51721H5.32198C3.96124 8.51721 2.8473 7.44143 2.78522 6.09577C2.84723 4.75005 3.96118 3.67433 5.32198 3.67433ZM30.1814 29.5739H5.32198C3.92155 29.5739 2.78223 28.4345 2.78223 27.0341V9.78126C3.50932 10.2683 4.38302 10.5526 5.32198 10.5526H30.1814C30.693 10.5526 31.1092 10.9688 31.1092 11.4805V15.6064H23.4505C20.8422 15.6064 18.7201 17.7283 18.7201 20.3367C18.7201 22.945 20.8422 25.067 23.4505 25.067H31.1092V28.646C31.1092 29.1576 30.693 29.5739 30.1814 29.5739ZM31.1092 23.0316H23.4505C21.9645 23.0316 20.7556 21.8227 20.7556 20.3367C20.7556 18.8507 21.9645 17.6418 23.4505 17.6418H31.1092V23.0316Z",
    fill: "#56DC53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.826 21.8116C24.6406 21.8116 25.3009 21.1512 25.3009 20.3367C25.3009 19.5221 24.6406 18.8618 23.826 18.8618C23.0114 18.8618 22.3511 19.5221 22.3511 20.3367C22.3511 21.1512 23.0114 21.8116 23.826 21.8116Z",
    fill: "#56DC53"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.4,
    height: 32.4,
    fill: "white",
    transform: "translate(0.744629 0.424072)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.7eec599aef9f6c487d2388ecf442527a.svg";
export { ForwardRef as ReactComponent };